import { Link as MuiLink } from '@mui/material';
import type { ReactElement } from 'react';
import { LinkBase } from 'react-admin';

import { fontWeights } from '@/ui/tokens';

/**
 * Lien de navigation des ecrans de connexion (« Mot de passe oublié ? »).
 *
 * Encre `accentPinkStrong` et non `primary` : posee sur le fond de page, la
 * seconde ne tient que 4,45:1 (`tokens.contrast.test.ts`). Soulignee en
 * permanence — un lien dans une ligne de formulaire ne doit pas se reconnaitre a
 * sa seule couleur.
 */
export const AuthLink = ({ to, children }: { readonly to: string; readonly children: string }): ReactElement => (
  <MuiLink
    component={LinkBase}
    to={to}
    underline="always"
    sx={{ fontSize: 14, fontWeight: fontWeights.bold, color: 'tokens.accentPinkStrong' }}
  >
    {children}
  </MuiLink>
);
